import { useEffect } from 'react'
import type { FieldValues, UseFormReturn } from 'react-hook-form'

export function useFormAutosave<T extends FieldValues>(
    form: UseFormReturn<T>,
    storageKey: string
) {
    const { watch, reset } = form

    useEffect(() => {
        const raw = localStorage.getItem(storageKey)

        if (raw) {
            try {
                reset(JSON.parse(raw), { keepDirty: true })
            } catch {
                console.error('Error parsing form data from localStorage')
            }
        }
    }, [storageKey, reset])

    useEffect(() => {
        const sub = watch((values) => {
            console.log('Autosave triggered:', values)
            try {
                localStorage.setItem(storageKey, JSON.stringify(values))
            } catch {}
        })

        return () => sub.unsubscribe()
    }, [watch, storageKey])

    const clearDraft = () => localStorage.removeItem(storageKey)

    return { clearDraft }
}
